import { MF_ACCESS_TOKEN } from '../constants/index.js';
import { getTokenObjectFromValue } from './get-token-obj-from-value.js';
export const storeAccessToken = (token) => {
    const mfToken = getTokenObjectFromValue(token);
    window.localStorage.setItem(MF_ACCESS_TOKEN, JSON.stringify(mfToken));
};
//# sourceMappingURL=store-access-token.js.map